import { render, staticRenderFns } from "./ESDStandardization.vue?vue&type=template&id=42966fdf&"
import script from "./ESDStandardization.vue?vue&type=script&lang=js&"
export * from "./ESDStandardization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports